<template>
  <div class="ele-body">
    <el-card shadow="never">
      <el-form
        :model="where"
        label-width="77px"
        class="ele-form-search"
        @keyup.enter.native="reload"
        @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :lg="6" :md="12">
            <el-form-item label="用户名称">
              <el-select
                v-model="where.user_id"
                multiple
                clearable
                filterable
                allow-create
                class="ele-block"
                placeholder="请选择">
                <el-option
                  v-for="item in userList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.username" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="用户订单">
              <el-input clearable v-model="where.merchantOrderNo" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="系统订单">
              <el-input clearable v-model="where.orderNo" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="交易类型">
              <el-select clearable class="ele-block" v-model="where.channel_id" placeholder="请选择">
                <el-option
                  v-for="item in channelList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.channel_name" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="通道订单">
              <el-input clearable v-model="where.pay_trade_no" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="10">
            <el-form-item label="交易状态">
              <el-select clearable class="ele-block" v-model="where.order_status" placeholder="请选择">
                <el-option v-for="item in orderStatusOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="10">
            <el-form-item label="账变状态">
              <el-select clearable class="ele-block" v-model="where.is_balance" placeholder="请选择">
                <el-option v-for="item in isBalanceOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="16" :md="24">
            <el-form-item label="选择时间">
              <div class="inorder-time-wrap">
                <el-radio-group v-model="timeQuick" size="small" @change="onTimeQuickChange">
                  <el-radio-button label="today">今日</el-radio-button>
                  <el-radio-button label="yesterday">昨日</el-radio-button>
                  <el-radio-button label="week">本周</el-radio-button>
                  <el-radio-button label="month">本月</el-radio-button>
                  <el-radio-button label="lastMonth">上月</el-radio-button>
                  <el-radio-button label="days30">30日</el-radio-button>
                </el-radio-group>
                <el-date-picker
                  v-model="where.time"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  @change="onTimePickerChange" />
              </div>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <div class="ele-form-actions">
              <el-button type="primary" icon="el-icon-search" class="ele-btn-icon" @click="reload">查询</el-button>
              <el-button @click="reset">重置</el-button>
              <el-button type="danger" icon="el-icon-document" size="small" class="ele-btn-icon" @click="onExportClick"
                v-if="permission.includes('sys:inorder:export')">导出</el-button>
              <el-button type="primary" icon="el-icon-refresh" size="small" class="ele-btn-icon" @click="startAutoRefresh">开启</el-button>
              <el-button type="primary" icon="el-icon-refresh" size="small" class="ele-btn-icon" @click="stopAutoRefresh">关闭</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <div class="inorder-stat-bar">
        <span>订单总量: {{ dataList.total_count }}</span>
        <span>成功数量: {{ dataList.success_count }}</span>
        <span>失败数量: {{ dataList.fail_count }}</span>
        <span>订单总金额: {{ dataList.total_amount }}</span>
        <span>成功金额: {{ dataList.success_amount }}</span>
        <span>失败金额: {{ dataList.fail_amount }}</span>
        <span>成功率: {{ dataList.success_rate }}</span>
        <span>手续费: {{ dataList.mch_rate_total }} 元</span>
        <span>订单费率: {{ dataList.mch_fees_total }} 元</span>
      </div>

      <ele-pro-table
        ref="table"
        :where="where"
        :datasource="url"
        :columns="columns"
        :page-size="20"
        height="calc(100vh - 330px)"
        class="inorder-table"
        @done="onTableDone">
        <template slot="toolbar">
          <el-button size="small" type="warning" icon="el-icon-refresh" class="ele-btn-icon" @click="initData"
            v-if="permission.includes('sys:inorder:edit')">
            清空
          </el-button>
        </template>
        <template slot="orderTradeStatus" slot-scope="{ row }">
          <div>
            <div>
              订单状态:
              <span :style="{ color: Number(row.order_status) === 4 ? '#F56C6C' : '#67C23A' }">
                {{ Number(row.order_status) === 4 ? '异常' : '正常' }}
              </span>
            </div>
            <div>交易状态: <dict-tag dict-code="order_related_status" field="order_status" :value="row.order_status" :show-value="false" text-only /></div>
          </div>
        </template>
        <template slot="callbackBalanceStatus" slot-scope="{ row }">
          <div>
            <div>回调状态: <dict-tag dict-code="order_related_status" field="callback_status" :value="row.callback_status" :show-value="false" text-only /></div>
            <div>账变状态: <dict-tag dict-code="order_related_status" field="is_balance" :value="row.is_balance" :show-value="false" text-only /></div>
          </div>
        </template>
        <template slot="action" slot-scope="{ row }">
          <div class="inorder-action">
            <el-button type="primary" size="mini" class="ele-btn-icon" @click="show(row)">详情</el-button>
            <el-button
              v-if="Number(row.order_status) === 0 && isUpstreamOrder(row) && permission.includes('sys:inorder:query')"
              type="warning"
              size="mini"
              class="ele-btn-icon"
              :loading="queryLoadingId === row.id"
              @click="queryOrder(row)">查单</el-button>
          </div>
        </template>
        <template slot="userOrderInfo" slot-scope="{ row }">
          <div>
            <div>商户昵称: {{ row.nickname }}</div>
            <div>
              商户订单:
              <span
                v-if="row.merchantOrderNo"
                class="copyable-text"
                title="点击复制完整订单号"
                @click="copyText(row.merchantOrderNo)">{{ formatShortOrderNo(row.merchantOrderNo) }}</span>
            </div>
          </div>
        </template>
        <template slot="requestExpireInfo" slot-scope="{ row }">
          <div>
            <div>请求时间: {{ row.timeStart }}</div>
            <div>超时时间: {{ formatTime(row.expire_time) }}</div>
          </div>
        </template>
        <template slot="channelPayTypeInfo" slot-scope="{ row }">
          <div>
            <div>通道名称: {{ formatChannelName(row) }}</div>
            <div>通道类型: {{ row.channel_type_name }}</div>
          </div>
        </template>
        <template slot="channelInPayerInfo" slot-scope="{ row }">
          <div>
            <div>收款姓名: {{ row.inPayerName }}</div>
            <div>收款账号: {{ formatMaskedAccount(row.inPayerAccount, row.inPayerBankName) }}</div>
          </div>
        </template>
        <template slot="orderNoInfo" slot-scope="{ row }">
          <div>
            <div>
              系统订单:
              <span
                v-if="row.orderNo"
                class="copyable-text"
                title="点击复制完整订单号"
                @click="copyText(row.orderNo)">{{ formatShortOrderNo(row.orderNo) }}</span>
            </div>
            <div>
              通道订单:
              <span
                v-if="row.pay_trade_no"
                class="copyable-text"
                title="点击复制完整订单号"
                @click="copyText(row.pay_trade_no)">{{ formatShortOrderNo(row.pay_trade_no) }}</span>
            </div>
          </div>
        </template>
        <template slot="amountInfo" slot-scope="{ row }">
          <div>
            <div>
              交易金额: {{ row.paymentAmount }}<template v-if="row.paymentCurrency">({{ row.paymentCurrency }})</template>
            </div>
            <div>实际到账: {{ row.real_amount }}</div>
          </div>
        </template>
        <template slot="feeInfo" slot-scope="{ row }">
          <div>
            <div>交易费率: {{ row.mch_fees }}</div>
            <div>手续费用: {{ row.mch_rate }}</div>
          </div>
        </template>
        <template slot="orderTimeInfo" slot-scope="{ row }">
          <div>
            <div>创建时间: {{ formatTime(row.create_time) }}</div>
            <div>更新时间: {{ formatTime(row.update_time) }}</div>
          </div>
        </template>
      </ele-pro-table>
    </el-card>

    <show
      :order-id="currentId"
      :initial-tab="detailTab"
      :visible.sync="showEdit" />

    <export-progress-dialog ref="exportDialog" biz="inorder" title="导出代收订单" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getDictData, loadDictOptions } from '@/utils/dict';
import ExportProgressDialog from '@/components/ExportProgressDialog.vue';
import Show from './show.vue';

const EMPTY_STATS = {
  total_count: 0,
  success_count: 0,
  fail_count: 0,
  total_amount: '0',
  success_amount: '0',
  fail_amount: '0',
  success_rate: '0%',
  mch_rate_total: '0',
  mch_fees_total: '0'
};

export default {
  name: 'Inorder',
  components: { Show, ExportProgressDialog },
  computed: {
    ...mapGetters(['permission'])
  },
  data() {
    return {
      url: '/Inorder/index',
      columns: [
        { columnKey: 'id', prop: 'id', label: '序号', width: 60, align: 'center', showOverflowTooltip: true, fixed: 'left' },
        { columnKey: 'userOrderInfo', label: '昵称/商户订单', prop: 'userOrderInfo', showOverflowTooltip: false, minWidth: 200, align: 'left', slot: 'userOrderInfo' },
        { columnKey: 'requestExpireInfo', label: '请求/超时时间', prop: 'requestExpireInfo', showOverflowTooltip: false, minWidth: 220, align: 'left', slot: 'requestExpireInfo' },
        { columnKey: 'channelPayTypeInfo', label: '通道/通道类型', prop: 'channelPayTypeInfo', showOverflowTooltip: false, minWidth: 180, align: 'left', slot: 'channelPayTypeInfo' },
        { columnKey: 'orderNoInfo', label: '系统/通道订单', prop: 'orderNoInfo', showOverflowTooltip: false, minWidth: 200, align: 'left', slot: 'orderNoInfo' },
        { columnKey: 'channelInPayerInfo', label: '收款信息', prop: 'channelInPayerInfo', showOverflowTooltip: false, minWidth: 220, align: 'left', slot: 'channelInPayerInfo' },
        { columnKey: 'amountInfo', label: '金额信息', prop: 'amountInfo', showOverflowTooltip: false, minWidth: 150, align: 'left', slot: 'amountInfo' },
        { columnKey: 'feeInfo', label: '费率信息', prop: 'feeInfo', showOverflowTooltip: false, minWidth: 150, align: 'left', slot: 'feeInfo' },
        { columnKey: 'orderTimeInfo', label: '创建/更新时间', prop: 'orderTimeInfo', showOverflowTooltip: false, minWidth: 220, align: 'left', slot: 'orderTimeInfo' },
        { columnKey: 'orderTradeStatus', label: '订单/交易状态', prop: 'orderTradeStatus', showOverflowTooltip: false, minWidth: 160, align: 'left', slot: 'orderTradeStatus', fixed: 'right' },
        { columnKey: 'callbackBalanceStatus', label: '回调/账变状态', prop: 'callbackBalanceStatus', showOverflowTooltip: false, minWidth: 150, align: 'left', slot: 'callbackBalanceStatus', fixed: 'right' },
        { columnKey: 'action', label: '操作', width: 168, align: 'center', resizable: false, slot: 'action', fixed: 'right' }
      ],
      where: { user_id: [], time: null },
      timeQuick: 'today',
      currentId: null,
      detailTab: 'request_json',
      showEdit: false,
      channelList: [],
      userList: [],
      dataList: { ...EMPTY_STATS },
      intervalId: null,
      orderStatusOptions: [],
      isBalanceOptions: [],
      queryLoadingId: null
    };
  },
  created() {
    this.applyTimeQuick('today', false);
  },
  mounted() {
    getDictData('order_related_status');
    loadDictOptions('in_order_status').then((list) => { this.orderStatusOptions = list; }).catch((e) => { this.$message.error(e.message); });
    loadDictOptions('yes_no').then((list) => { this.isBalanceOptions = list; }).catch((e) => { this.$message.error(e.message); });
    this.loadFilters();
    this.getInorderCount();
  },
  beforeDestroy() {
    this.stopAutoRefresh();
  },
  methods: {
    buildSearchParams() {
      return {
        ...this.where,
        user_id: Array.isArray(this.where.user_id)
          ? this.where.user_id.join(',')
          : this.where.user_id
      };
    },
    onTableDone() {
      this.$nextTick(() => {
        if (this.$refs.table && this.$refs.table.doLayout) {
          this.$refs.table.doLayout();
        }
      });
    },
    formatMaskedAccount(account, bankName) {
      if (!account) return '';
      let masked = account;
      if (account.length >= 7) {
        masked = `${account.slice(0, 3)}****${account.slice(-4)}`;
      }
      return bankName ? `${masked}(${bankName})` : masked;
    },
    formatShortOrderNo(orderNo) {
      if (!orderNo) return '';
      const text = String(orderNo);
      return text.length <= 14 ? text : `${text.slice(0, 6)}...${text.slice(-6)}`;
    },
    formatChannelName(row) {
      if (!row) return;
      return row.channel_display_name || row.up_channel_name;
    },
    isUpstreamOrder(row) {
      if (!row) return false;
      if (Number(row.channel_source) === 1) return false;
      if (Number(row.channel_source) === 2) return true;
      return Number(row.uplist_id) > 0;
    },
    formatTime(value) {
      return value ? this.$util.toDateString(value) : '';
    },
    copyText(text) {
      if (!text) return;
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.left = '-999999px';
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        this.$message.success('复制成功');
      } catch (err) {
        this.$message.error('复制失败');
      }
      document.body.removeChild(textarea);
    },
    pad2(n) {
      return n < 10 ? `0${n}` : `${n}`;
    },
    formatDateTime(date) {
      const d = date instanceof Date ? date : new Date(date);
      return `${d.getFullYear()}-${this.pad2(d.getMonth() + 1)}-${this.pad2(d.getDate())} ${this.pad2(d.getHours())}:${this.pad2(d.getMinutes())}:${this.pad2(d.getSeconds())}`;
    },
    getTimeRange(key) {
      const now = new Date();
      const start = new Date(now);
      const end = new Date(now);
      start.setHours(0, 0, 0, 0);
      end.setHours(23, 59, 59, 0);

      if (key === 'today') {
        return [this.formatDateTime(start), this.formatDateTime(end)];
      }
      if (key === 'yesterday') {
        start.setDate(start.getDate() - 1);
        end.setDate(end.getDate() - 1);
        return [this.formatDateTime(start), this.formatDateTime(end)];
      }
      if (key === 'week') {
        const day = start.getDay() || 7;
        start.setDate(start.getDate() - day + 1);
        return [this.formatDateTime(start), this.formatDateTime(end)];
      }
      if (key === 'month') {
        start.setDate(1);
        return [this.formatDateTime(start), this.formatDateTime(end)];
      }
      if (key === 'lastMonth') {
        start.setMonth(start.getMonth() - 1, 1);
        end.setDate(0);
        end.setHours(23, 59, 59, 0);
        return [this.formatDateTime(start), this.formatDateTime(end)];
      }
      if (key === 'days30') {
        start.setDate(start.getDate() - 29);
        return [this.formatDateTime(start), this.formatDateTime(end)];
      }
      return null;
    },
    applyTimeQuick(key, doReload = true) {
      this.timeQuick = key;
      this.where.time = this.getTimeRange(key);
      if (doReload) {
        this.reload();
      }
    },
    onTimeQuickChange(key) {
      this.applyTimeQuick(key, true);
    },
    onTimePickerChange() {
      this.timeQuick = '';
    },
    reload() {
      this.$refs.table.reload({ where: this.buildSearchParams() });
      this.getInorderCount();
    },
    reset() {
      this.where = { user_id: [], time: null };
      this.applyTimeQuick('today', true);
    },
    initData() {
      this.$confirm('初始化将清空全部代收订单且不可恢复，确定继续？', '提示', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({ lock: true });
        this.$http.post('/Inorder/initData').then((res) => {
          loading.close();
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.reload();
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch((e) => {
          loading.close();
          this.$message.error(e.message);
        });
      }).catch(() => {});
    },
    show(row) {
      this.currentId = row.id;
      this.detailTab = 'request_json';
      this.showEdit = true;
    },
    queryOrder(row) {
      if (!row || !row.id || this.queryLoadingId) {
        return;
      }
      this.queryLoadingId = row.id;
      this.$http
        .post('/Inorder/queryOrder', { id: row.id })
        .then((res) => {
          this.queryLoadingId = null;
          if (res.data.code !== 0) {
            this.$message.error(res.data.msg || '查单失败');
            return;
          }
          this.$message.success(res.data.msg || '查单成功');
          this.reload();
        })
        .catch((e) => {
          this.queryLoadingId = null;
          this.$message.error(e.message);
        });
    },
    getInorderCount() {
      this.$http.post('/Inorder/getInorderCount', this.buildSearchParams()).then((res) => {
        if (res.data.code === 0) {
          this.dataList = res.data.data || { ...EMPTY_STATS };
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch((e) => {
        this.$message.error(e.message);
      });
    },
    startAutoRefresh() {
      if (this.intervalId != null) return;
      this.intervalId = setInterval(() => {
        this.reload();
      }, 10000);
    },
    stopAutoRefresh() {
      if (this.intervalId == null) return;
      clearInterval(this.intervalId);
      this.intervalId = null;
    },
    loadFilters() {
      // 筛选项为跨模块只读接口；失败时静默，避免「有菜单却连弹无权限」
      Promise.all([
        this.$http.post('/ChannelColumnIn/getchannelList'),
        this.$http.get('/UserBalancesRecords/getUserList')
      ]).then(([channelRes, userRes]) => {
        if (channelRes.data && channelRes.data.code === 0) {
          this.channelList = channelRes.data.data || [];
        }
        if (userRes.data && userRes.data.code === 0) {
          this.userList = userRes.data.data || [];
        }
      }).catch(() => {});
    },
    onExportClick() {
      this.$refs.exportDialog.start(this.buildSearchParams());
    }
  }
};
</script>

<style scoped>
.inorder-stat-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 28px;
  margin-bottom: 12px;
  padding: 10px 16px;
  background: #f5f7fa;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  font-size: 14px;
  color: #606266;
  line-height: 1.6;
}

.inorder-table ::v-deep .el-table td {
  padding-top: 8px;
  padding-bottom: 8px;
}

.inorder-table ::v-deep .el-table td > .cell {
  white-space: normal;
  line-height: 1.55;
}

.inorder-action {
  display: inline-flex;
  flex-wrap: nowrap;
  align-items: center;
  white-space: nowrap;
  gap: 6px;
}

.inorder-action .el-button + .el-button {
  margin-left: 0;
}

.copyable-text {
  color: #409eff;
  cursor: pointer;
}

.copyable-text:hover {
  color: #66b1ff;
}

.inorder-time-wrap {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}
</style>
